<template>
  <div>
    <iframe :src="pdfUrl" width="100%" height="800px" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  props: {
    pdfUrl: {
      type: String,
      required: true
    }
  }
}
</script>